import React from 'react';

import NordeaFinance from 'public/assets/logotype/nordeafinance-blue.svg';
import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { Icon, IconType } from 'components/tokens/Icon';
import { Colors } from 'enums/Colors';
import { arrowRight } from 'icons/default';
import { blipp } from 'icons/logo';
import { getFormattedPrice } from 'utils/getFormattedPrice';
import { calculateMonthlyCost } from 'lib/loanCalculator/calculateMonthlyCostPrivateLoan';
import useUser from 'lib/auth/useUser';
import { isLoggedIn } from 'lib/auth/AuthContext';

import styles from './Buy.module.scss';

interface Props {
  totalCost: number;
  monthlyCost: number;
  leasable: boolean;
  licensePlate: string;
}

export const Buy: React.FC<Props> = ({ totalCost, monthlyCost, leasable, licensePlate }) => {
  const { user } = useUser();

  const getCalculatorQueryParams = () => {
    const params = new URLSearchParams();

    if (licensePlate && isLoggedIn(user)) {
      params.append('licensePlate', licensePlate);
    }

    if (totalCost) {
      params.append('total-cost', totalCost.toString());
    }

    if (Array.from(params).length === 0) {
      return '';
    }

    return `?${params.toString()}`;
  };

  let priceBody;
  let showNordeLogo;

  if (monthlyCost) {
    priceBody = (
      <>
        <div className={styles.prices}>
          <span className={styles['total-price']}>Pris:&nbsp;</span>
          <span>{getFormattedPrice(totalCost)}</span>
        </div>
        <div className={styles.prices}>
          <span className={styles['monthly-price']}>{monthlyCost.toLocaleString()}&nbsp;</span>
          <span>kr / månad</span>
        </div>

        <p>
          Förbered din affär genom att ansöka om ett billån. Låna med bilen som säkerhet precis som
          hos bilhandlaren.
        </p>
        <Button
          type={ButtonType.Button}
          size={ButtonSize.Large}
          trailingIcon={arrowRight}
          href={`/lanelofte-billan${getCalculatorQueryParams()}`}
          nofollow
        >
          Räkna på månadskostnad
        </Button>
      </>
    );
    showNordeLogo = (
      <div className={styles.buyBottom}>
        <hr className={styles.dark} />
        <NordeaFinance />
        <p>I samarbete med Nordea Finance</p>
      </div>
    );
  } else if (false && totalCost > 25000 && totalCost < 400000) {
    priceBody = (
      <>
        <div>
          <div className={styles.prices}>
            <span className={styles['monthly-price']}>
              {calculateMonthlyCost(totalCost).toLocaleString()}&nbsp;
            </span>
            <span>kr / månad</span>
          </div>
          <div className={styles.prices}>
            <span className={styles['total-price']}>Pris:&nbsp;</span>
            <span>{getFormattedPrice(totalCost)}</span>
          </div>
        </div>
        <div className={styles.example}>
          <h3>Kostnadsexempel med Blipp</h3>
          <p>
            Privatlån med {process.env.NEXT_PUBLIC_PRIVATE_LOAN_INTEREST?.replace('.', ',')}% ränta,
            10 års återbetalningstid.
          </p>
        </div>
      </>
    );
  } else {
    priceBody = (
      <div className={styles.prices}>
        <span className={styles['total-price']}>Pris:&nbsp;</span>
        <span>{getFormattedPrice(totalCost)}</span>
      </div>
    );
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <h2>{monthlyCost ? 'Finansiera med Blipp' : 'Köp med Blipp'}</h2>
        <Icon icon={blipp} type={IconType.Fill} color={Colors.DarkBlue} size={40} />
      </div>
      <div className={styles.container}>
        {priceBody}

        {leasable && (
          <Button
            type={ButtonType.Button}
            size={ButtonSize.Large}
            trailingIcon={arrowRight}
            href={`/foretag/foretagsleasing${getCalculatorQueryParams()}`}
            variant={ButtonVariant.Ghost}
          >
            Företagsleasa
          </Button>
        )}
        {showNordeLogo}
      </div>
    </div>
  );
};
